<template>
  <div class="main-content partner_orders">
    <div class="card">
      <div class="card-body">
        <div v-if="!loading" class="text-right">
          <LoadingButton
            title="Обновить заявки"
            :loading="loading"
            type="button"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => getOrders()"
            className="btn btn-outline-success"
          />
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-3"/>

        <template v-if="records && records.length">
          <table class="table table-sm table-hover mt-1">
            <thead>
            <tr>
              <th>ID заказа</th>
              <th>Клиент</th>
              <th>Статус</th>
              <th>Препараты</th>
              <th>Стоимость</th>
              <!--              <th>Резерв</th>-->
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(o,i) in records" :class="{'reserveComing': o.allowToShif, 'collected': o.status === 2}">
              <td>{{ o.id }}</td>
              <td>
                <p>{{ o.details.order.name }}</p>
                <p><strong>{{ o.details.order.mPhone }}</strong></p>
                <p class="text-muted">{{ printDate(o.created_at) }}</p>
              </td>
              <td>
                <div v-html="printStatus(o.status)"/>
              </td>
              <td>
                <p v-for="d in o.details.drugs">{{ d.title }} x <strong>{{ d.qty }}</strong> x
                  <strong>{{ d.price }}</strong></p>
                <hr class="mt-1 mb-1">
                <div>
                  <input @change="updateOrder(o.id, 'partner_comment')" v-model="o.details.partner_comment" type="text"
                         placeholder="Комментарий к заказу"
                         class="form-control">
                </div>
              </td>
              <td>
                <strong>{{ o.price }}</strong>
              </td>
              <td>
                <p v-if="o.status === 2">Резерв до: <strong>{{ printDate(o.details.reservedDate) }}</strong></p>
                <div>
                  <template v-if="o.status === 2">
                    <v-popover
                      placement="left"
                    >
                      <button type="button" class="btn mb-2 btn-xs btn-outline-success">Заказ выполнен</button>
                      <template slot="popover">
                        <p>Заказ выкуплен клиентом?</p>
                        <LoadingButton
                          title="Подтвердить выполнение заказа"
                          :loading="btnLoading[o.id]"
                          type="button"
                          :color="$constants.PRIMARY_COLOR"
                          :onClick="() => updateOrder(o.id, 'close')"
                          className="mb-2 btn btn-xs btn-success"
                        />
                      </template>
                    </v-popover>

                  </template>
                  <template v-else>
                    <LoadingButton
                      title="Заказ собран"
                      :loading="btnLoading[o.id]"
                      type="button"
                      :color="$constants.PRIMARY_COLOR"
                      :onClick="() => updateOrder(o.id, 'ready')"
                      className="mb-2 btn btn-xs btn-outline-info"
                    />
                  </template>

                  <LoadingButton
                    v-if="o.allowToShif"
                    title="Продлить бронь"
                    :loading="btnLoading[o.id]"
                    type="button"
                    :color="$constants.PRIMARY_COLOR"
                    :onClick="() => updateOrder(o.id, 'reservedDate')"
                    className="mb-2 btn btn-xs btn-outline-info"
                  />

                  <v-popover
                    placement="left"
                  >
                    <button type="button" class="btn btn-xs btn-outline-warning">Отменить заказ</button>
                    <template slot="popover">
                      <form @submit.prevent="updateOrder(o.id, 'reject')">
                        <textarea
                          placeholder="Причина отказа"
                          class="form-control"
                          rows="2"
                          v-model="o.reject_reason"
                          required
                        />
                        <LoadingButton
                          title="подтвердить отмену"
                          :loading="btnLoading[o.id]"
                          type="submit"
                          color="white"
                          :onClick="() => {}"
                          className="mt-2 btn btn-xs btn-warning"
                        />
                      </form>
                    </template>
                  </v-popover>

                </div>
                <!--                <DateSelect-->
                <!--                  ref="selectedDateComponent"-->
                <!--                  :disabled="true"-->
                <!--                  :disableEdit="false"-->
                <!--                  :useDisabledDates="disabledDates"-->
                <!--                  :selectedDate="o.details.reservedDate"-->
                <!--                  :onSelect="(date) => o.details.reservedDate = date"-->
                <!--                />-->
                <!--                <LoadingButton-->
                <!--                  title="Обновить дату"-->
                <!--                  :loading="btnLoading[o.id]"-->
                <!--                  type="button"-->
                <!--                  :color="$constants.PRIMARY_COLOR"-->
                <!--                  :onClick="() => updateOrder(o.id, 'reservedDate')"-->
                <!--                  className="btn btn-outline-info"-->
                <!--                />-->
              </td>
              <td v-if="false">
                <v-dropdown :show-arrow="false">
                  <a
                    slot="activator"
                    href="#"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    class="avatar"
                  >
                    <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            class="btn btn-default dropdown-toggle1">
                      <template v-if="btnLoading[o.id]">
                        <clip-loader
                          :loading="true"
                          :color="$constants.LOADING_COLOR"
                          size="20px"
                        />
                      </template>
                      <template v-else>
                        <i class="icon-fa icon-fa-ellipsis-v"></i>
                      </template>
                    </button>
                  </a>
                  <v-dropdown-item>
                    <!--                    <span class="small_title">Уведомления</span>-->
                    <template v-if="o.status === 0">
                      <a @click="updateOrder(o.id, 'ready')" class="dropdown-item pointer">Заказ собран</a>
                    </template>
                    <!--                    <template v-if="o.status === 1">-->
                    <!--                      <a @click="updateOrder(o.id, 'ready')" class="dropdown-item pointer">Заказ собран</a>-->
                    <!--                    </template>-->
                    <template v-if="o.status === 2">
                      <a @click="updateOrder(o.id, 'close')" class="dropdown-item pointer">Заказ закрыт</a>
                    </template>
                    <a @click="updateOrder(o.id, 'reject')" class="dropdown-item pointer">Отменить заказ</a>

                  </v-dropdown-item>
                </v-dropdown>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
        <template v-else>
          <template v-if="!loading">
            <h5 class="text-center">На данный момент активных заявок нет</h5>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton";
import DropdownMenu from '@innologica/vue-dropdown-menu'
import DateSelect from '@/components/dateSelect/DateTimeSelect'
import moment from "moment";

export default {
  components: {
    LoadingButton,
    DropdownMenu,
    DateSelect,
  },
  data() {
    return {
      btnLoading: {},
      disabledDates: null,
      loading: false,
      records: []
    }
  },
  created() {
    this.disabledDates = new Date();
    this.disabledDates = this.disabledDates.setDate(this.disabledDates.getDate() + 1);
    this.getOrders();
  },
  methods: {
    async updateOrder(id, action) {
      if (this.btnLoading[id]) return;
      this.btnLoading[id] = true;
      this.btnLoading = {...this.btnLoading};
      const {data} = await api.post('/new/orders/partner', {
        order_id: id,
        action: action,
        orderData: this.records.find((o) => o.id === id),
      })
      if (data.success) {
        this.getOrders();
        toastr['success']('Сохранено');
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.btnLoading[id] = false;
    },
    printStatus(status) {
      switch (status) {
        case 0:
          return '<span class="badge badge-info">Новая</span>';
        case 1:
          return '<span class="badge badge-info">Принят</span>';
        case 2:
          return '<span class="badge badge-success">Собран</span>';
        case 3:
          return '<span class="badge badge-success">Закрыт</span>';
      }
      return;
    },
    async getOrders() {
      this.loading = true;
      this.btnLoading = {};
      this.records = [];
      const {data} = await api.index('/new/orders/partner');
      if (data.success) {
        // this.records = [];
        this.records = data.records.reduce((acc, o) => {
          if (!o.details.reservedDate) {
            o.details.reservedDate = moment(o.created_at).add(2, 'days').format('YYYY.MM.DD 21:00:00');
          }
          if (moment(o.details.reservedDate).diff(moment(), 'minutes') < 900) {
            o.allowToShif = true;
          }
          acc.push({...o, price: o.details.drugs.reduce((acc, d) => acc + (d.qty * d.price), 0)})
          return acc
        }, []);
      } else {
        this.records = [];
        toastr['warning'](data.message || 'Ошибка загрузки заявок');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.card-body {
  height: 80vh;
  overflow: auto;
}

tr.collected {
  background-color: #eaffea;
}

table.table tr.reserveComing {
  background-color: #e2efff;
}

table.table {
  margin-bottom: 45px;
}
</style>

<style>
.v-clip {
  vertical-align: middle;
}

.partner_orders .dropdown-container.align-right {
  background-color: white !important;
}

.partner_orders .dropdown-container.align-right .dropdown-item {
  color: #16181b !important;
}

.partner_orders .dropdown-container.align-right .dropdown-item:hover {
  color: #fff !important;
}
</style>
